import { cn } from '@nexelem/utils';
import { type PropsWithChildren, useEffect } from 'react';
import { ResetFiltersButton } from './ResetFiltersButton';
import { closeSavedViewsDrawer, SavedViewButton } from '../saveViewFeature';
import { DropdownMenu, IconButton } from '@nexelem/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';
import { ColumnsOrderButton } from '../columnsOrderFeature';
import { closeColumnsOrderDrawer } from '../columnsOrderFeature/ColumnsOrderDrawer';
import { ExportToCsvButton } from '../exportToCsvFeature';
import { useTableTranslation } from '../translations';
import { AdvancedFiltersButton } from '../components';

type FiltersContainerProps = {
  onAdvancedFiltersClick?: () => void;
  /** Provide file name to enable export to CSV */
  enableExportToCsv?: string;
  className?: string;
  withDropdown?: boolean;
};

export const FiltersContainer = ({
  children,
  onAdvancedFiltersClick,
  enableExportToCsv,
  className,
  withDropdown = true,
}: PropsWithChildren<FiltersContainerProps>) => {
  const { t } = useTableTranslation();
  useCloseSavedViewsDrawerOnUnmountEffect();

  return (
    <div className={cn('flex h-11 shrink-0 items-center gap-4 px-6 pb-4', className)}>
      {children}
      {withDropdown && (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <IconButton aria-label={t('moreOptions')} Icon={<FontAwesomeIcon icon={faEllipsisVertical} />} />
          </DropdownMenu.Trigger>
          <DropdownMenu.Content>
            {onAdvancedFiltersClick && <AdvancedFiltersButton onClick={onAdvancedFiltersClick} />}
            <ColumnsOrderButton />
            <SavedViewButton />
            {enableExportToCsv && <ExportToCsvButton fileName={enableExportToCsv} />}
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      )}
      <ResetFiltersButton />
    </div>
  );
};

const useCloseSavedViewsDrawerOnUnmountEffect = () => {
  useEffect(
    () => () => {
      closeSavedViewsDrawer();
      closeColumnsOrderDrawer();
    },
    [],
  );
};
